import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, useTheme } from '@mui/material';
import type { MuiTelInputCountry } from 'mui-tel-input';

import Field from '@/components/fields/Field';
import PhoneInput from '@/components/fields/PhoneInput';
import TextInput from '@/components/fields/TextInput';

interface AdminInviteFormProps {
  namePrefix?: string;
  defaultCountry?: MuiTelInputCountry;
}

const AdminInviteForm: React.FC<AdminInviteFormProps> = ({ namePrefix = 'admin', defaultCountry }) => {
  const { t } = useTranslation('organizations');
  const { spacing } = useTheme();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: spacing(2),
        '& .MuiFormControl-root': {
          p: 0
        }
      }}
    >
      <Field
        component={TextInput}
        name={`${namePrefix}.email`}
        label={t('layouts.organizations.create.fields.adminEmail')}
        markAsRequired
        withFormControl
        innerProps={{
          type: 'email'
        }}
      />
      <Field
        component={PhoneInput}
        name={`${namePrefix}.phone`}
        label={t('layouts.organizations.create.fields.adminPhone')}
        markAsRequired
        withFormControl
        innerProps={{
          defaultCountry
        }}
      />
    </Box>
  );
};

export default AdminInviteForm;
